<template>
  <div :class="rootClasses">
    <div class="flex align-items-center flex-wrap">
      <label v-if="$slots.label" :for="id" class="flex-grow-1">
        <slot name="label" />
      </label>

      <label v-if="$slots.labelLeft" :for="id" class="mr-3 label-right" @click.stop="handleClick">
        <slot name="labelLeft" />
      </label>

      <PVInputSwitch
        v-bind="$attrs"
        :inputId="id"
        v-model="value"
        :pt="{
          hiddenInput: {
            'aria-describedby': `${id}-value-text`,
          },
        }"
        :aria-label="$attrs['aria-label'] ? String($attrs['aria-label']) : undefined"
      />

      <label v-if="$slots.labelRight" :for="id" class="ml-3 label-right" @click.stop="handleClick">
        <slot name="labelRight" />
      </label>

      <span v-if="$slots.valueText" class="ml-2 font-normal" :id="`${id}-value-text`">
        <slot name="valueText" />
      </span>
    </div>

    <span v-if="$slots.helperText" class="caption mt-2">
      <slot name="helperText" />
    </span>
  </div>
</template>

<script setup lang="ts">
import PVInputSwitch from 'primevue/inputswitch';
import { computed, useAttrs, watchEffect } from 'vue';
import { useInputDisabled, useInputRequired } from '../composables';

defineOptions({
  inheritAttrs: false,
  name: 'InputSwitch',
});

const attrs = useAttrs();

// Define props
defineProps({
  id: {
    type: String,
    required: true,
  },
});

const value = defineModel<any>();

const { disabled, classes: disabledClasses } = useInputDisabled(attrs.disabled as boolean);

const { required, classes: requiredClasses } = useInputRequired(attrs.required as boolean);

const rootClasses = computed(() => {
  return [
    'field-input-switch',
    disabledClasses.value,
    requiredClasses.value,
    {
      'p-error': Boolean((attrs.class as string)?.includes('p-invalid')),
    },
  ];
});

watchEffect(() => {
  disabled.value = Boolean(attrs.disabled);
  required.value = Boolean(attrs.required);
});

const handleClick = (event: Event) => {
  if (attrs['@click.stop']) {
    (attrs['@click.stop'] as Function)(event);
  }
};
</script>
